module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Flip-vertical-12ef2c6dc949681157de91bcb3dd63af.svg";